<template>
  <v-select
    :data-test-id="dataTestId"
    :label="computedLabel"
    v-model="valueInternal"
    :disabled="disabled"
    :rules="rules"
    :items="selectableGames"
    item-text="name"
    item-value="code"
    :placeholder="placeholder"
    :prepend-icon="prependIcon"
    :autocomplete="autocomplete"
    :persistent-placeholder="true"
    :hint="hint"
    :clearable="clearable"
  >
    <template v-slot:default="data">
      <span>HELLO {{data}}</span>
    </template>
    <template v-slot:item="data">
      <v-icon class="mr-2">{{ data.item.mdi_icon }}</v-icon>
      <span
        :class="'text-uppercase' + (!data.item.active ? ' inactive' : '')"
        >{{ data.item.name }}</span
      >
    </template>

    <template v-slot:selection="data">
      <v-icon class="mr-2">{{ data.item.mdi_icon }}</v-icon>
      <span class="text-uppercase">{{ data.item.name }}</span>
    </template>
  </v-select>
</template>

<script>
import envMixin from "@/mixins/envMixin";

export default {
  name: "GameSelect",
  components: {},
  mixins: [envMixin],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    label: {
      type: String,
    },
    rules: {
      default: undefined,
    },
    value: {
      required: false,
    },
    prependIcon: {
      type: String,
    },
    autocomplete: {
      type: String,
    },
    dataTestId: {
      type: String,
      required: false,
      default: "game",
    },
    placeholder: {
      type: String,
      required: false
    },
    hint: {
      type: String,
      required: false
    },
    allGames: {
      type: Boolean,
      default: false,
    }
  },
  data: function () {
    return {
      valueInternal: undefined,
    };
  },
  computed: {
    computedLabel: function () {
      return this.label ? this.label : this.$t("common.game");
    },
    selectableGames() {
      let isSuperUser = this.isSuperUser()
      if(this.allGames){
        return this.$store.state.games.filter((game) => {
          return isSuperUser || game.active == true;
        })
      } else {
        return this.$store.state.games.filter((game) => {
          return isSuperUser || game.code.includes('pro-clubs');
        })
      }
    },
  },
  watch: {
    value: function (val) {
      this.valueInternal = val;
    },
    valueInternal: function (val) {
      this.$emit("input", val);
    },
  },
  mounted() {
    this.valueInternal = this.value;
  },
  methods: {},
};
</script>
